import { FormEvent } from "react"
import { Head, Link, useForm, usePage } from "@inertiajs/react"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

export default function PasswordNew() {
  const { props } = usePage<PageProps>()
  const form = useForm({ email: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/passwords")
  }

  return (
    <>
      <Head title="Reset Password | LeadFlow">
        <meta name="description" content="Request a password reset link for your LeadFlow account." />
        <meta property="og:title" content="Reset Password | LeadFlow" />
        <meta property="og:description" content="Request a password reset link for your LeadFlow account." />
      </Head>
      <AuthShell>
        <h1 className="text-3xl">Reset your password</h1>
        <p className="mt-2 text-sm text-ink-muted">
          Enter your email address to request a reset link.
        </p>

        {props.flash?.notice && (
          <p className="mt-4 rounded-md border border-hairline bg-page px-3 py-2 text-sm text-ink-body">
            {props.flash.notice}
          </p>
        )}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <label htmlFor="email">Email</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={form.data.email}
              onChange={(e) => form.setData("email", e.target.value)}
            />
          </div>
          <Button type="submit" disabled={form.processing}>
            Send reset instructions
          </Button>
        </form>

        <p className="mt-6">
          <Link href="/login" className="text-accent-display hover:text-accent">Back to log in</Link>
        </p>
      </AuthShell>
    </>
  )
}
